import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import Switch from 'react-toggle-switch';

class SwitchItem extends Component {
	shouldComponentUpdate = ({
		labelText, switch1Value, switch2Value, children,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.labelText, labelText)
			|| !isEqual(lastProps.switch1Value, switch1Value)
			|| !isEqual(lastProps.switch2Value, switch2Value)
			|| !isEqual(lastProps.children, children)
		);
	};

	render() {
		const {
			labelText, switch1Value, switch2Value, onChange, property, children,
		} = this.props;
		return (
			<div>
				<div className="flex">
					<div className="flex-3">
						{ labelText }
					</div>
					<div className="text-right flex-1 toggle-switch">
						<Switch
							on={switch1Value}
							// className="toggle-switch"
							onClick={() => onChange(property, 'email')}
						/>
					</div>
					<div className="text-right flex-1 toggle-switch">
						<Switch
							on={switch2Value}
							// className="toggle-switch"
							onClick={() => onChange(property, 'sms')}
						/>
					</div>
				</div>
				{ children }
				<div className="separator separator-blue" />
			</div>
		);
	}
}

SwitchItem.propTypes = {
	labelText    : PropTypes.string,
	switch1Value : PropTypes.bool,
	switch2Value : PropTypes.bool,
	property     : PropTypes.string,
	onChange     : PropTypes.func.isRequired,
	children     : PropTypes.element.isRequired,
};

SwitchItem.defaultProps = {
	labelText    : '',
	switch1Value : true,
	switch2Value : true,
	property     : 'clockIn',
};

export default SwitchItem;
